module.exports = __webpack_public_path__ + "static/media/change_icon.08e9a67f.svg";